export const convertPenniesToRub = (pennies, withoutCurrency = true) => {
  const fixedRub = (pennies / 100).toFixed(2);
  const formattedRub = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  }).format(fixedRub);

  return withoutCurrency ? formattedRub.slice(0, -2) : formattedRub;
};
